import { render, staticRenderFns } from "./SchoolCreate.vue?vue&type=template&id=0fa0fd90&"
import script from "./SchoolCreate.vue?vue&type=script&lang=js&"
export * from "./SchoolCreate.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports